import React from 'react'
import './AnimatedIcon.css'

function AnimatedExclamation (props) {
    return (
        <svg className="svg" version="1.1" viewBox="0 0 130.2 130.2">
            <circle className="path circle" fill="none" stroke="#fadb53" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
            <line className="path line" fill="none" stroke="#fadb53" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="65" y1="30.9" x2="65" y2="85.3" />
            <circle className="path line-delayed" fill="none" stroke="#fadb53" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="105.1" r="2.0" />
        </svg>
    )
}

export default AnimatedExclamation
